import Vue from 'vue'
import Topic from '~components/content/post-types/Topic.vue'
import Comment from '~components/content/post-types/Comment.vue'

Vue.component('Topic', Topic)

Vue.component('Comment', Comment)
